import React from 'react'
import { TextField, TextFieldProps } from '@mui/material'

const TrimmedTextField = ({ onBlur, ...props }: TextFieldProps) => {
  const handleBlur = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const trimmed = event.target.value.trim()
    if (trimmed !== event.target.value) {
      // Can't call props.onChange directly: event.target is a live DOM node and
      // can't be meaningfully cloned. Using the native setter lets React's reconciler
      // read the updated value from the real element as it normally would.
      const nativeInput = event.target
      const proto =
        nativeInput instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype
      const nativeSetter = Object.getOwnPropertyDescriptor(proto, 'value')?.set
      nativeSetter?.call(nativeInput, trimmed)
      nativeInput.dispatchEvent(new Event('input', { bubbles: true }))
    }
    onBlur?.(event)
  }
  return <TextField onBlur={handleBlur} {...props} />
}

TrimmedTextField.displayName = 'TrimmedTextField'

export default TrimmedTextField
